import { render, staticRenderFns } from "./PersonalizedView.vue?vue&type=template&id=2f6b7638&scoped=true"
import script from "./PersonalizedView.vue?vue&type=script&lang=js"
export * from "./PersonalizedView.vue?vue&type=script&lang=js"
import style0 from "./PersonalizedView.vue?vue&type=style&index=0&id=2f6b7638&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6b7638",
  null
  
)

export default component.exports